import axios from "axios";
import { ApiBaseUrl, apiUrls as ApiUrls } from "../constants/endpoints";
export const LOGIN_URL = ApiBaseUrl + "Account/Authenticate";
export const REGISTER_URL = "auth/register";
export const REQUEST_PASSWORD_URL = "auth/forgot-password";
export const ME_URL = "me";

const getAuthToken = () => {
  var token = JSON.parse(localStorage.getItem("gentell-fastcare-authToken"));
  if (token === null || token === "") return "";
  return "Bearer " + token;
};
export const axiosInstance = axios.create();

function Logout(errorCode = "ex") {
  window.location.assign("/logout?se=" + errorCode);
}

axiosInstance.interceptors.request.use(
  function (config) {
    const token = getAuthToken();

    if (token != null) {
      config.headers.Authorization = token;
    }

    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    // // 
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Only a genuine auth failure (a real HTTP 401 from the server) should force a logout.
    // A response-less error (timeout / network drop / aborted long request) must NOT log the user
    // out: the request may already have succeeded server-side — e.g. a slow Release-to-Brightree
    // whose post-push work (queue advance + PDF) outlives the connection. Logging out there strands
    // the operator and hides the real outcome. Let the caller's own .catch handle it. (Bug 4092)
    if (error.response) {
      if (error.response.status === 401) Logout();
    } else {
      // Response-less error (timeout / network drop / abort). Log to the CONSOLE only — never via a
      // network call: Common.LogError posts through this same axiosInstance, so a failing log request
      // would re-enter this handler and recurse into a request storm when the network is down. (Bug 4092)
      // eslint-disable-next-line no-console
      console.error("API call failed with no response (network/timeout).", error);
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export function login(email, password) {
  axios.post(LOGIN_URL, {
    Username: email,
    Password: password,
  });
}
export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}
export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}
export function getUserByToken() {
  return axios.get(ME_URL);
}
export function getRequest(url, bindBaseUrl = true) {
  return axiosInstance.get(bindBaseUrl ? ApiBaseUrl + url : url);
}
/** Authenticated GET returning binary (e.g. PDF). Use for iframe/embed previews. */
export function getRequestBlob(url) {
  return axiosInstance.get(ApiBaseUrl + url, { responseType: "blob" });
}
/** Authenticated POST returning binary (e.g. ZIP). */
export function postRequestBlob(url, data) {
  return axiosInstance.post(ApiBaseUrl + url, data, { responseType: "blob" });
}
export function getRequestById(url, id) {
  return axiosInstance.get(ApiBaseUrl + url + "?id=" + id);
}

export function getRequestQry(url, stringQuery) {
  return axiosInstance.get(ApiBaseUrl + url + stringQuery);
}

export function postRequest(url, requestParameters, bindBaseUrl = true, config = undefined) {
  // `config` is an optional per-request axios override (e.g. { timeout: 120000 } for
  // long-running calls). Passing it here keeps the shared axiosInstance defaults intact.
  return axiosInstance.post(
    bindBaseUrl ? ApiBaseUrl + url : url,
    requestParameters,
    config
  );
}

// ── PECOS sync-all start/poll ────────────────────────────────────────────────
// These use a bare axios call (NOT axiosInstance) so they bypass the shared
// response interceptor that force-logs-out on any error — a transient failure
// during the ~2s status poll must retry, never log the admin out. Auth header is
// attached manually.
function pecosAuthHeaders() {
  const token = getAuthToken();
  return token ? { Authorization: token } : {};
}
export function startPecosSync() {
  return axios.post(ApiBaseUrl + Uri_PecosSync, {}, { headers: pecosAuthHeaders() });
}
export function getPecosSyncStatus() {
  return axios.get(ApiBaseUrl + Uri_PecosSyncStatus, { headers: pecosAuthHeaders() });
}

// Physician enrich + Brightree sync — start/poll background job. Bare axios (no
// logout-on-error interceptor) so a transient status poll never logs the user out.
export function startPhysicianSync(physicianIds) {
  return axios.post(ApiBaseUrl + URI_EnrichAndSyncPhysicians, physicianIds, { headers: pecosAuthHeaders() });
}
export function getPhysicianSyncStatus() {
  return axios.get(ApiBaseUrl + URI_EnrichAndSyncPhysicians + "/status", { headers: pecosAuthHeaders() });
}

// Signed CMN document upload. Bare axios for the same reason as the sync helpers above:
// the request waits on a live Brightree push, and a timeout produces a response-less
// error that the shared interceptor would mistake for an auth failure and log the user out.
// Content-Type is left unset so axios attaches the multipart boundary itself.
export function uploadSignedCmnDocuments(formData) {
  return axios.post(ApiBaseUrl + Uri_CmnSignedDocUpload, formData, {
    headers: pecosAuthHeaders(),
    timeout: 300000,
  });
}

export function putRequest(url, requestParameters) {
  if (requestParameters) {
    return axiosInstance.put(ApiBaseUrl + url, requestParameters);
  } else {
    return axiosInstance.put(ApiBaseUrl + url);
  }
}

export function patchRequest(url, requestParameters) {
  return axiosInstance.patch(ApiBaseUrl + url, requestParameters);
}

export function deleteRequest(url) {
  return axiosInstance.delete(ApiBaseUrl + url);
}
// export function changePassword(dataObj) {
//   return axios.put(CHANGE_PASSWORD, dataObj);
// }

//DropDown Constants
//#region  Lookup list Urls
export const Uri_GetDropdown = "DropDown/GetDropHeader";
export const Uri_GetHeaderValuesByID = "DropDown/GetTaxValueByID";
export const Uri_GetLookupValuesByFkId = "DropDown/GetDropDownValue";
export const Uri_GetWoundType = "DropDown/GetWoundType";
export const Uri_GetAllItemfrequencies = "DropDown/GetAllItemfrequencies";

export const Uri_GetAllICDDropDownList = "DropDown/GetAllICDDropDownList";
export const Uri_GetAllWoundType = "DropDown/GetAllWoundType";


export const Uri_GetBodyRegion = "DropDown/GetBodyRegion";

export const Uri_GetChainByOrgID = "DropDown/GetChainByOrgId";
export const Uri_GetOrganization = "DropDown/GetOrganization";
export const Uri_GetUserByRoleID = "DropDown/GetUserByRoleID";
/** Users eligible for Facility.CMNSpecialistID (main Add/Edit Facility). Query: ?search=term&ensureUserId=id (optional). */
export const Uri_GetCmnSpecialistUsers = "DropDown/GetCmnSpecialistUsers";

export const Uri_AddHeaderValues = "DropDown/create";
export const Uri_EditHeaderValues = "DropDown/update";
export const Uri_GetLookUp_PatientNoteReasonFetchAll = "DropDown/GetLookUp_PatientNoteReasonFetchAll";
export const Uri_GetResidentByFacilityId = "DropDown/GetResidentByFacilityId";

//Report Section
export const Uri_GetRptWoundAreaTrend = "Report/GetRptWoundAreaTrend";
export const Uri_GetWoundDocumentationByWoundID = "Report/GetWoundDocumentationByWoundID";
export const Uri_GetFacilityResidentWoundDocumentation = "Report/GetFacilityResidentWoundDocumentation";
export const Uri_GetFacilityReports = "Report/GetFacilityReports";
export const Uri_GetPintedAllAndSelectedReport = "Report/SavePintedAllAndSelectedReport";
export const Uri_GetQAPIReport = "Report/GetQAPIReport";



// end Report Section




export const Uri_UpdateSystemSettings = "SystemSettings/update";

export const Uri_GetState = "DropDown/GetState";
//#endregion

//#region Users URL
export const Uri_AddUser = "User/create";
export const Uri_EditUser = "User/update";
export const Uri_SetPasswordDetalURL = "User/validateChangePasswordURL";
export const Uri_GetSystemSetting = "User/GetSystemSetting";
export const Uri_GetRegionalManagerAndVicePresident = "User/getRegionalManagerAndVicePresident";
export const Uri_GetMaintenanceNotice = "SystemSettings/GetMaintenanceNotice";


export const Uri_GetRolesByUserID = "RoleAction/GetRolesByUserID";
export const Uri_UpdateUserStatus = "User/UpdateUserStatus";
//#endregion

//#region  Brightry
export const Uri_CreateResident = "Resident/CreateResident";
export const Uri_CreateSalesOrder = "Resident/CreateSalesOrder";
export const Uri_CreateNotes = "Resident/CreateNotes";
export const Uri_UpsertResidentNotes = "Resident/UpsertResidentNotes";
export const Uri_GetAllResidentNotesByResidentID =
  "Resident/GetAllResidentNotesByResidentID";
export const Uri_CreateInsurance = "Resident/CreateInsurance";
export const Uri_CreatePhysician = "Resident/UpsertPhysician";
export const URI_ValidateInsurance = "Resident/ValidateInsurance";
export const URI_UpdateInsuranceForResInfoUI = "Resident/UpdateInsForResInfoUI";

//#endregion

//#region Facility
export const Uri_AddFacility = "Facility/create";
export const Uri_SetBillingDate = "Facility/setBillingDate";
export const Uri_CreateFacilityGroup = "Facility/createFacilityGroup";
export const Uri_CreateFacilityMsg = "Facility/CreateFacilityMsg";
export const Uri_GetFacilityMsgsByFacilityId = "Facility/GetFacilityMsgsByFacilityId";

export const Uri_UpdateFacilityStatus = "Process/UpdateFacilityStatus";
export const Uri_UpdateSaleOrderStatus = "Process/UpdateSaleOrderStatus";
export const Uri_UpdateProcessQueue = "Process/UpdateProcessQueue";

export const Uri_AssignFacilityToBiller = "Process/AssignFacilityToBiller";
export const Uri_UpdateFacilityWithBiller = "Process/UpdateFacilityWithBiller";
export const Uri_UpdateBillingFacilityStatus =
  "Process/UpdateBillingFacilityStatus";
  export const Uri_UnReleaseBillingFacility =
  "Process/UnReleaseBillingFacility";
export const Uri_UpdateBillingSaleOrderStatus =
  "Process/UpdateBillingSaleOrderStatus";

export const Uri_UpdateFacility = "Facility/update";

export const Uri_GetFacility = "Facility/GetAllFacility";
export const Uri_GetFacilityResidentWoundOrder = "Facility/GetFacilityResidentWoundOrder";
export const Uri_GetWorkqueueFacility = "Facility/GetWorkqueueFacility";
export const Uri_GetWorkqueueFacilityList = "Facility/GetWorkqueueFacilityList";

export const Uri_GetOstomyFacilityAndResidentByStatusId = "Facility/GetOstomyFacilityAndResidentByStatusId";
export const Uri_GetUrologicalFacilityAndResidentByStatusId = "Facility/GetUrologicalFacilityAndResidentByStatusId";
export const Uri_GetTracheostomyFacilityAndResidentByStatusId = "Facility/GetTracheostomyFacilityAndResidentByStatusId";


export const Uri_GetBillingFacility = "Facility/GetBillingFacility";
export const Uri_GetPartailOrderFacilities = "Facility/GetPartailOrderFacilities";
export const Uri_GetClubbedFacilities = "Facility/GetClubbedFacilities";


export const Uri_GetFacilityByID = "Facility/GetByID";
export const Uri_GetFacilityStatusById = "Process/GetFacilityStatusById";

export const Uri_facilityFetchByBrightreeID = "Facility/facilityFetchByBrightreeID";
export const Uri_fetchAllFacility = "Facility/fetchAllFacility";
export const Uri_parseFacilityFile = "Facility/parseFacilityFile";
export const Uri_saveParseFacilityList = "Facility/saveParseFacilityList";
export const Uri_saveParseUserList = "User/SaveUsersFile";

export const Uri_getClinicianFacilities = "Facility/GetClinicianFacilities";
export const Uri_upsertFacilityClinician = "Facility/UpsertFacilityClinician";
export const Uri_processJob = "Process/FastCareAPI";
export const Uri_getNightlySyncLog = "Process/GetNightlySyncLog";

export const URI_GetFacilitesReport = "Process/GetFacilitesReport";
export const URI_GetResidentHistoryReport = "Process/GetResidentHistoryReport";




export const Uri_getSyncLog = "Facility/getSyncLog";

export const Uri_getFacilitiesByOrganizationId = "Facility/GetAllFacilitiesByOrganizationId";
export const Uri_updateFacilitiesOwnershipGroup = "Facility/UpdateFacilityOwnershipGroup";
export const Uri_updateFacilityClinician = "Facility/UpdateFacilityClinician";
export const Uri_getFacilitiesByClinicianId = "Facility/GetFacilitiesByClinicianId";

export const Uri_UpsertPostVisitDraft = "Facility/UpsertPostVisitDraft";
export const Uri_GetPostVisitDraft = "Facility/GetPostVisitDraft";

//#endregion

//#region Facility Consultant
export const URI_AddConsultant = "FacilityConsultant/create";
export const URI_GetAllFacilityConsultantByFacilityID =
  "FacilityConsultant/GetAllFacilityConsultantByFacilityID";
//#endregion

//ICD10
export const URI_GetICDCode = "ICD/GetICDCode";
export const URI_GetAllICDCode = "ICD/GetAllICDCode";
export const URI_UpsertWoundToIcd = "ICD/UpsertWoundToIcd";

//#region Physician

export const URI_UpsertPhysician = "Physician/UpsertPhysician";
export const URI_GetAllPhysician = "Physician/GetAllPhysician";
export const URI_DeletePhysician = "Physician/DeletePhysician";
export const URI_FetchPhysicianList = "Physician/FetchPhyList";
export const URI_UpsertPhysicianNew = "Physician/UpsertPhysicianFromGrid";
export const URI_SyncPhysician = "Physician/SyncPhysician";
export const URI_SyncPhysicians = "Physician/SyncPhysicians";
export const URI_ReplacePhysicianReferences = "Physician/ReplacePhysicianReferences";
export const URI_ReplacePhysician = "Physician/ReplacePhysician";
export const URI_UpdatePhysicianStatus = "Physician/UpdatePhysicianStatus";
export const URI_ActivePhysician = "Physician/ActivePhysician";
export const URI_DeactivePhysician = "Physician/DeactivePhysician";
export const URI_UnlinkPhysician = "Physician/UnlinkPhysician";
export const URI_SearchBTDoctorsByNPI = "Physician/SearchBTDoctorsByNPI";
export const URI_SearchBTDoctors = "Physician/SearchBTDoctors";
export const URI_EnrichAndSyncPhysicians = "Physician/EnrichAndSyncPhysicians";
//#endregion

//#region PECOS (CMS Order & Referring DME) URL — Administrator only
export const Uri_PecosVersionState = "pecos/version-state";
export const Uri_PecosCheckVersion = "pecos/check-version";
export const Uri_PecosSync = "pecos/sync";
export const Uri_PecosSyncStatus = "pecos/sync/status"; // GET — poll progress of the running sync-all job
export const Uri_PecosSyncByNpi = "pecos/sync/"; // append the 10-digit NPI
/** Admin manual override of a physician's PECOS flag. PUT Physician/{physicianId}/Pecos  Body { isPecos:bool }. */
export const Uri_PhysicianPecosOverride = "Physician/"; // usage: Uri_PhysicianPecosOverride + physicianId + "/Pecos"
//#endregion

//#region  Resident
// export const Uri_CreateNotes = "Resident/CreateNotes";
export const URI_UpsertResident = "Resident/UpsertResident";
export const URI_UpsertInsurance = "Resident/UpsertInsurance";

export const URI_GetAllResidentByFacilityID =
  "Resident/GetAllResidentByFacilityID";
export const URI_GetAllWorkQueueResidentByFacilityID =
  "Resident/GetAllWorkQueueResidentByFacilityID";
export const URI_GetAllBillingQueueResidentByFacilityID =
  "Resident/GetAllBillingQueueResidentByFacilityID";

  export const URI_GetResidentHistory =
  "Resident/GetResidentHistory";

  export const URI_GetProcessResidentByFacilityId =
  "Resident/GetProcessResidentByFacilityId";

  export const URI_GetFacilityHistoryById =
  "Facility/GetFacilityHistoryById";

export const Uri_GetAllInsurance = "Resident/GetAllInsurance";

export const Uri_GetInsurances = "Resident/GetInsurance";
export const Uri_ResidentSearchBt = "Resident/ResidentSearchBt";
export const Uri_ResidentSearchFC = "Resident/ResidentSearchFC";

export const URI_UpsertResidentInsurance = "Resident/UpsertResidentInsurance";
export const URI_GetAllResidentInsurance =
  "Resident/GetResidentInsuranceByResidentID";
export const URI_GetAllResidentInfoInsurances = "Resident/GetAllResidentInfoInsurances";  
export const URI_GetResidentWoundByResidentID =
  "Wound/GetResidentWoundByResidentID";
  export const URI_GetLastWoundDetailByWoundId =
  "Wound/GetLastWoundDetailByWoundId";

  export const URI_GetResidentWoundByStatusID =
  "Wound/GetResidentWoundByStatusID";

  export const URI_GetResidentWoundHistory =
  "Wound/GetResidentWoundHistory";

export const URI_GetWoundHistoryByWoundID = "Wound/GetWoundHistoryByWoundID";

export const URI_UpsertResidentWound = "Wound/UpsertResidentWound";

export const Uri_GetResidentsWithOrdersByFacilityId = "Resident/GetResidentsWithOrdersByFacilityId";
//#endregion

//#region SalesOrder
export const URI_GetAllProducts = "SaleOrder/GetAllProducts";
export const URI_UpsertSaleOrder = "SaleOrder/UpsertSaleOrder";
export const URI_GetSalesOrderMsgsBySalesOrderId = "SaleOrder/GetSalesOrderMsgsBySalesOrderId";
export const URI_GetSkipResidentMsgsByResidentId = "resident/GetSkipResidentMsgsByResidentId";
export const URI_GetSkipWoundMsgsByResidentId = "wound/GetSkipWoundsMsgsByResidentId";

export const URI_GetWoundInfoChangeDetailByWoundId = "wound/GetWoundInfoChangeDetailByWoundId";




export const URI_CreateSalesOrderMsg = "SaleOrder/CreateSalesOrderMsg";

export const URI_GetSaleOrderByResidentWoundID =
  "SaleOrder/GetSaleOrderByResidentWoundID";
//#endregion


//#region  OUTs
export const URI_UpsertOstomySaleOrderInBrightreeSOAP = "OUTs/UpsertOstomySaleOrderInBrightreeSOAP";
export const URI_GetOstomySaleOrderByResidentId =
  "OUTs/GetOstomySaleOrderByResidentId";
  export const URI_ProcessOstomySaleOrderById =
  "OUTs/ProcessOstomySaleOrderById";
  export const URI_UpdateOstomyBillingOUtsOrderStatusByFacilityID =
  "OUTs/UpdateOstomyBillingOUtsOrderStatusByFacilityID";

//#endregion
export const URI_UpsertUrologicalSaleOrder = "OUTs/UpsertUrologicalSaleOrder";
export const URI_GetUrologicalSaleOrderByResidentId =
  "OUTs/GetUrologicalOrderByResidentID";
  export const URI_ProcessUrologicalSaleOrderById =
  "OUTs/ProcessUrologicalSaleOrderById";
  export const URI_UpdateUrologicalBillingOUtsOrderStatusByFacilityID =
  "OUTs/UpdateUrologicalBillingOUtsOderStatusByFacilityID";

  export const URI_UpsertTracheostomySaleOrder = "OUTs/UpsertTracheostomySaleOrder";
export const URI_GetTracheostomySaleOrderByResidentId =
  "OUTs/GetTracheostomySaleOrderByResidentId";
  export const URI_ProcessTracheostomySaleOrderById =
  "OUTs/ProcessTracheostomySaleOrderById";

  export const URI_UpdateTracheostomyBillingOUtsOrderStatusByFacilityID =
  "OUTs/UpdateTracheostomyBillingOUtsOrderStatusByFacilityID";
export const apiUrls = ApiUrls;

export const URI_GetSaleOrderByResident = "Report/PrintSalesOrderReport";

export const URI_LogFeature = "FeatureLog/log";

export const URI_FeatureSwitch = "FeatureSwitch/feature/";
export const URI_GetFeatureSwitches = "FeatureSwitch/all";
export const URI_UpsertFeatureSwitch = "FeatureSwitch";

// Feedback
export const URI_FeedbackSubmit = "Feedback/submit";

//#region CMN Queue
export const Uri_CmnFacilityList = "CMN/Facility/List";
export const Uri_CmnFacilityInfo = "CMN/Facility/Info/";
export const Uri_CmnProviderList = "CMN/Provider/List";
export const Uri_CmnProviderInfo = "CMN/Provider/Info/";
export const Uri_CmnPendingList = "CMN/Pending/List";
export const Uri_CmnSignedDocUpload = "CMN/signed-documents/upload";
export const Uri_CmnDocuSignCreateEnvelope = "DocuSign/CreateEnvelope";
/** Void a sent packet — voids the linked DocuSign envelope (bidirectional). Body: { packetId, reason }. */
export const Uri_CmnDocuSignVoidPacket = "DocuSign/VoidPacket";
/** Current recipient (signer) email on a packet's active envelope. GET, append packetId. */
export const Uri_CmnDocuSignRecipientEmail = "DocuSign/RecipientEmail/";
/** Update the signer's email on a packet's active DocuSign envelope. Body: { packetId, newEmail }. */
export const Uri_CmnDocuSignUpdateEmail = "DocuSign/UpdateRecipientEmail";
/** Current recipient fax number on a faxed packet's active envelope. GET, append packetId. */
export const Uri_CmnDocuSignRecipientFax = "DocuSign/RecipientFax/";
/** Update the fax recipient's number on a packet's active faxed envelope. Body: { packetId, newFax }. */
export const Uri_CmnDocuSignUpdateFax = "DocuSign/UpdateRecipientFax";
/** Fax delivery (v1 single recipient). POST body: CreateFaxEnvelopeRequest */
export const Uri_CmnDocuSignCreateFaxEnvelope = "DocuSign/CreateFaxEnvelope";
/** Resend the SAME DocuSign envelope unchanged (no new packet). Body: { packetId, markAsResend, sendEnvelope }. */
export const Uri_CmnDocuSignResendEnvelope = "DocuSign/ResendEnvelope";
export const Uri_CmnDocumentPreview    = "CMN/Document/Preview/";
export const Uri_CmnDocumentBulkDownload = "CMN/Document/BulkDownload";
export const Uri_CmnDispatchList = "CMN/Dispatch/List";
export const Uri_CmnExceptionsList = "CMN/Exceptions/List";
// Lookup endpoints — populate dropdowns on Facility & Provider info tabs
export const Uri_CmnLookupPhysicians        = "CMN/Lookup/Physicians";
/** All active physicians (non-PECOS-filtered) for the Medical Director signing-physician picker */
export const Uri_CmnLookupSigningPhysicians = "CMN/Lookup/Physicians/Signing";
export const Uri_CmnLookupDeliveryMethods = "CMN/Lookup/DeliveryMethods";
export const Uri_CmnLookupFrequencies     = "CMN/Lookup/Frequencies";
export const Uri_CmnLookupContactMethods  = "CMN/Lookup/ContactMethods";
/** Role-tagged eligible signers for a DocuSign envelope. Query: ?facilityId=N or ?physicianId=N */
export const Uri_CmnLookupEligibleSignees = "CMN/Lookup/EligibleSignees";
/** Packet CMN drill-down. Append /{groupId}/Cmns */
export const Uri_CmnDispatchPacketCmns   = "CMN/Dispatch/Packet/";
/** Modify-and-Resend audit trail (#4180 AC25-35). Append {groupId}/History to Uri_CmnDispatchPacketCmns. */

/** Providers (physicians with ≥1 pending CMN in territory) for the bulk Ordering-Doctor dropdown. */
export const Uri_CmnCrudProviders        = "CmnCrud/Providers";
/** Bulk update Ordering Doctor on selected CMNs (Brightree + FastCare). POST { assignments:[...] } */
export const Uri_CmnCrudOrderingDoctor   = "CmnCrud/OrderingDoctor";
//#endregion

//# region Jurisdiction
export const Uri_GetJurisdiction = "Jurisdiction/GetJurisdiction";
export const Uri_GetAllJurisdiction = "Jurisdiction/GetAllJurisdiction"
export const Uri_UpdateJurisdictionSupervisorByID = "Jurisdiction/UpdateJurisdictionSupervisorByID"
// # endregion

export function submitFeedback(data) {
  return axiosInstance.post(ApiBaseUrl + URI_FeedbackSubmit, data);
}
